<script lang="ts" setup>
import helpers from '~/helpers'
import type { CategoryData } from '~/types/categories'

withDefaults(
  defineProps<{
    categoriesData?: CategoryData[]
    tagsData?: any[]
  }>(),
  { categoriesData: () => [], tagsData: () => [] }
)

async function routeTo (categoryData: CategoryData): Promise<void> {
  await navigateTo(helpers.getCategoryPath(categoryData))
}
</script>

<template>
  <Carousel drag-free :show-buttons="false">
    <div class="flex select-none lg:flex-wrap">
      <TaxonomyCarouselItem
        v-for="x in categoriesData"
        :key="x.id"
        class="mb-0 mr-2 last:mr-0 lg:mb-2"
        :title="x.attributes.name"
        @click.prevent="routeTo(x)"
      >
        {{ x.attributes.name }}
      </TaxonomyCarouselItem>

      <TaxonomyCarouselItem
        v-for="x in tagsData"
        :key="x.id"
        class="mb-0 mr-2 cursor-default last:mr-0 lg:mb-2"
        :title="x.attributes.name"
      >
        {{ x.attributes.name }}
      </TaxonomyCarouselItem>
    </div>
  </Carousel>
</template>
